export default class Mask {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        value = value.replace(/[^a-zA-Z0-9]/g, '');

        if(value.match(/^[a-zA-Z][0-9]/)) {
            if (value.match(/^[a-zA-Z][0-9]{2}[a-zA-Z]/)) {
                return '** ***';
            }
            else {
                return '*** ***';
            }
        }
        else {
            if (value.match(/^[a-zA-Z]{2}[0-9]{2}[a-zA-Z]/)) {
                return '*** ***';
            }
            else {
                return '**** ***';
            }
        }
    }

    birthdate() {
        return '39-19-2999';
    }
}
